import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';

interface StylesProps {
  withoutBorder?: boolean;
  activeValue?: boolean;
  activeSubValue?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles<string, StylesProps>({
    root: {
      padding: '8px 0',
      borderBottom: ({ withoutBorder }) =>
        withoutBorder ? 'auto' : '1px solid rgba(224, 224, 224, 1)',
    },
    label: {
      display: 'flex',
      justifyContent: ({ withoutBorder }) =>
        withoutBorder ? 'flex-start' : 'flex-end',
      alignItems: 'center',
      paddingRight: '16px',
      height: '100%',
      lineHeight: '15px',
    },
    value: {
      lineHeight: '15px',
      color: ({ activeValue }) =>
        activeValue ? theme.palette.primary.main : 'inherit',
      cursor: ({ activeValue }) => (activeValue ? 'pointer' : 'auto'),
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    subValue: {
      fontSize: '12px',
      lineHeight: '12px',
      color: ({ activeSubValue }) =>
        activeSubValue ? theme.palette.primary.main : 'inherit',
      cursor: ({ activeSubValue }) => (activeSubValue ? 'pointer' : 'auto'),
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  })
);

interface RegisterFieldProps {
  label?: string;
  withoutBorder?: boolean;
  value?: string;
  subValue?: string;
  valueLink?: () => void;
  subValueLink?: () => void;
}

export function RegisterField({
  label,
  withoutBorder,
  value,
  subValue,
  valueLink,
  subValueLink,
}: RegisterFieldProps) {
  const classes = useStyles({
    withoutBorder,
    activeValue: !!valueLink,
    activeSubValue: !!subValueLink,
  });

  return (
    <Grid container className={classes.root}>
      <Grid item xs={4}>
        <Typography variant="body1" className={classes.label}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography
          variant="body2"
          className={classes.value}
          onClick={valueLink}
        >
          {value ?? ''}
        </Typography>
        {subValue && (
          <Typography
            variant="body2"
            className={classes.subValue}
            onClick={subValueLink}
          >
            {subValue}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
}
